import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormGroup,
  FormControlLabel,
  Snackbar,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";
import SelectAutoComplete from "../../ui/selectAutoComplete/SelectAutoComplete";
import { useState, useEffect } from "react";
import { getTiposVisitas } from "../../components/functions/Projects";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/es-mx";

const CrearVisitaModal = ({ open, onClose, onConfirm, API_URL }) => {
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [tiposVisita, setTiposVisita] = useState([]);

  const [visitaForm, setVisitaForm] = useState({
    tipoVisita: null,
    fecha: dayjs(),
    mostrarReporte: true,
    comentarios: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      const res = await getTiposVisitas(API_URL);
      setTiposVisita(res);
    };

    if (open) {
      fetchData();
    }
  }, [open]);

  const handleClose = () => {
    onClose();
    setVisitaForm({
      tipoVisita: null,
      fecha: dayjs(),
      mostrarReporte: true,
      comentarios: "",
    });
  };

  const handleConfirm = async () => {
    if (!visitaForm?.tipoVisita) {
      setShowSnackbar(true);
      setSnackbarMessage("Por favor, seleccione un tipo de visita.");
      return;
    }
    await onConfirm({
      ...visitaForm,
      fecha: visitaForm?.fecha?.toISOString(),
    });
    setVisitaForm({
      tipoVisita: null,
      fecha: dayjs(),
      mostrarReporte: true,
      comentarios: "",
    });
  };

  return (
    <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={3000}
        onClose={() => {
          setShowSnackbar(false);
          setSnackbarMessage("");
        }}
        message={snackbarMessage}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          content: {
            sx: {
              backgroundColor: "white",
              color: "#222",
              justifyContent: "center",
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16px",
              fontFamily: "Roboto, Arial, sans-serif",
            },
          },
        }}
      />
      <DialogTitle>Estatus de libranza</DialogTitle>
      <DialogContent>
        <div
          style={{
            height: "400px",
            padding: "8px 0",
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            width: "100%",
          }}
        >
          <SelectAutoComplete
            label="Tipo"
            fieldC="descripcion"
            options={tiposVisita}
            value={visitaForm?.tipoVisita}
            onChange={(e, value) =>
              setVisitaForm((prev) => ({ ...prev, tipoVisita: value }))
            }
            placeholder="Seleccionar..."
            size="small"
            width={"100%"}
            listHeight="200px"
          />
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="es-mx"
          >
            <DatePicker
              label="Fecha"
              value={visitaForm?.fecha}
              onChange={(newValue) =>
                setVisitaForm((prev) => ({ ...prev, fecha: newValue }))
              }
              sx={{ margin: "10px  0 0", width: "100%" }}
            />
          </LocalizationProvider>
          <FormGroup
            sx={{
              height: "min-content",
              textWrap: "nowrap",
              alignSelf: "flex-start",
            }}
          >
            <FormControlLabel
              control={
                <Switch
                  checked={visitaForm?.mostrarReporte}
                  onChange={(e) =>
                    setVisitaForm((prev) => ({
                      ...prev,
                      mostrarReporte: !prev.mostrarReporte,
                    }))
                  }
                />
              }
              label="Mostrar en reporte"
              labelPlacement="start"
              sx={{ margin: "0" }}
            />
          </FormGroup>
          <div style={{ height: "120px" }}>
            <label className="form-label">Comentarios:</label>
            <textarea
              className="form-input"
              placeholder="Comentarios..."
              value={visitaForm?.comentarios}
              onChange={(e) => {
                setVisitaForm((prev) => ({
                  ...prev,
                  comentarios: e.target.value,
                }));
              }}
            />
          </div>
        </div>
      </DialogContent>
      <DialogActions>
        <CustomButton
          background={"#FFFFFF"}
          color={"#223D51"}
          text="Cancelar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          type="button"
          width={"100px"}
          onClick={handleClose}
        />
        <CustomButton
          background={"#223D51"}
          color={"#FFFFFF"}
          text="Guardar"
          height="40px"
          fontWeight="700"
          fontSize="14px"
          border="1px solid #D9D9D9"
          onClick={handleConfirm}
          type="button"
          width={"100px"}
        />
      </DialogActions>
    </Dialog>
  );
};

export default CrearVisitaModal;
